// @ts-ignore
import coreStore from '@/stores/core';

export const isAutoPopup = () => {
  return (coreStore.safeGetStore('userStore').newABTestingConfigs as any)?.article_popup_or_no_popup === 'pop_up';
};

export const isSeparate = () => {
  return (coreStore.safeGetStore('userStore').newABTestingConfigs as any)?.faq_placement === 'separate_bubble';
};

export const isScrollToUnread = () => {
  return (coreStore.safeGetStore('userStore').newABTestingConfigs as any)?.article_auto_scroll === 'scroll_to_unread';
};

export const isOldUI = () => {
  if ((coreStore.safeGetStore('userStore').newABTestingConfigs as any)?.article_popup_or_no_popup === undefined) {
    return true;
  } else {
    return (coreStore.safeGetStore('userStore').newABTestingConfigs as any)?.article_popup_or_no_popup === 'control';
  }
};
